import { useEffect, useState } from 'react';

/* const DEFAULT_MIN_VERSIONS = {
  chrome: '145',
  edge: '145',
  firefox: '146',
  safari: '18',
};

const checkForUnknownBrowser = (minVersions) => {
  const browserData = window.navigator.userAgent?.toLowerCase();
  const supportedBrowserNames = Object.entries(minVersions).map(([key]) => key);

  for (const name of supportedBrowserNames) {
    if (browserData.includes(name)) {
      return false;
    }
  }

  return true;
};

const checkBrowserVersion = (minVersions) => {
  const browserData = window.navigator.userAgent?.toLowerCase();

  for (const [browser, minVersion] of Object.entries(minVersions)) {
    const regex = `${browser}\\/(\\d+)`;
    const match = browserData.match(regex);

    if (match) {
      const majorVersion = parseInt(match[1], 10);
      if (majorVersion < minVersion) {
        return false;
      }
    }
  }

  return true;
}; */

const defaultFeatureCheck = () => {
  return (
    typeof window !== 'undefined' &&
    'fetch' in window &&
    'Promise' in window &&
    'localStorage' in window &&
    'IntersectionObserver' in window &&
    'ResizeObserver' in window &&
    'AbortController' in window &&
    'MutationObserver' in window
  );
};


const useBrowserVersion = (options = {}) => {
  const {
    //minVersions = DEFAULT_MIN_VERSIONS,
    //treatUnknownAsUnsupported = false,
    checkRequiredFeatures = defaultFeatureCheck,
  } = options;
  const [ browserSupported, setBrowserSupported ] = useState(true);

  useEffect(() => {
    const hasRequiredFeatures = checkRequiredFeatures();
    /* 

    // 2026-03-26 - Stoyan Prokopov: leaving this commented 
    // in case we ever decide to do more thorough browser check

    const browserIsUnknown = checkForUnknownBrowser(minVersions);
    const browserVersionIsOk = checkBrowserVersion(minVersions);

    let result = false;

    if (browserIsUnknown && treatUnknownAsUnsupported) {
      result = true;
    } else if (browserIsUnknown && !treatUnknownAsUnsupported) {
      result = false;
    } else if (!browserIsUnknown) {
      result = browserVersionIsOk && hasRequiredFeatures;
    }  */

    setBrowserSupported(hasRequiredFeatures);
  }, []);


  return {
    browserSupported
  };
};

export default useBrowserVersion;
